<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        운전자정보
    </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                ID
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm"
                        formControlName="userId"
                        [ngClass]="{'is-invalid':(submitted && f.userId.errors) || checkSameId === false}"
                        [readonly]="dtgActionType !== DtgActionType.create"
                        ngbAutofocus>
                    <div class="invalid-tooltip" *ngIf="submitted && f.userId.errors">
                        <div *ngIf="f.userId.errors.required">필수 입력 항목 입니다</div>
                    </div>
                    <div class="invalid-tooltip" *ngIf="checkSameId === false">
                        <div>이미 사용중인 id 가 있는지 확인이 필요합니다</div>
                    </div>
                    <div class="input-group-append"
                        [hidden]="dtgActionType !== DtgActionType.create">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            [disabled]="dtgActionType !== DtgActionType.create"
                            (click)="clickCheckSameId()">
                            <i class="mdi mdi-account-check"></i>
                            <span class="ml-1">중복확인</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                비번
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="password" class="form-control form-control-sm"
                           formControlName="userPw"
                           [ngClass]="{'is-invalid':submitted && f.userPw.errors}">
                    <div class="invalid-tooltip" *ngIf="submitted && f.userPw.errors">
                      <div *ngIf="f.userPw.errors.required">필수 입력 항목 입니다</div>
                    </div>
                    <div class="input-group-append"
                         [hidden]="dtgActionType !== DtgActionType.update">
                        <button type="button" class="btn btn-sm btn-outline-warning"
                                (click)="clickUserPwReset()">
                            <i class="mdi mdi-account-key"></i>
                            <span class="ml-1">재설정</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-9 offset-md-3 small mt-1"
                   [hidden]="!userPwReset">
                <small class="form-text text-muted">
                  {{userPwReset}}
                </small>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                소속회사
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm"
                        formControlName="companyNm"
                        readonly>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="clickOpenModalCompanyInfo(DtgActionType.read)"
                            [disabled]="dtgActionType === DtgActionType.create">
                            회사변경
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                사용자권한
            </label>
            <div class="col-md-9 position-relative">
                <select class="form-control form-control-sm w-auto"
                    formControlName="userGroupId"
                    [ngClass]="{'is-invalid':submitted && f.userGroupId.errors}">
                    <option *ngFor="let item of listUserGroup;"
                        [ngValue]="item.userGroupId">
                        {{item.userGroupNm}}
                    </option>
                </select>
                <div class="invalid-tooltip" *ngIf="submitted && f.userGroupId.errors">
                    <div *ngIf="f.userGroupId.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                그룹
            </label>
            <div class="col-md-9 position-relative">
                <select class="form-control form-control-sm w-auto"
                    formControlName="dtgTeamId">
                    <option [ngValue]="null">그룹 미설정</option>
                    <option *ngFor="let item of listTeam;"
                        [ngValue]="item.dtgTeamId">
                        {{item.dtgTeamNm}}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                이름
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="userNm">
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
              운전자코드
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                       maxlength="18"
                       formControlName="dtgDriverLcsNo"
                       [ngClass]="{'is-invalid':submitted && f.dtgDriverLcsNo.errors}">
                <div class="invalid-tooltip" *ngIf="submitted && f.dtgDriverLcsNo.errors">
                  <div *ngIf="f.dtgDriverLcsNo.errors.pattern">입력 형식을 확인 해 주세요</div>
                </div>
            </div>
            <div class="col-md-9 offset-md-3 small mt-1">
                <small class="form-text text-muted">
                  운전종사자자격증 또는 운전자사번 또는 주민번호 뒤 7자리<br>
                  '-' 하이픈을 제외 한 숫자만 입력
                </small>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
              운수종사자ID
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    maxlength="18"
                    formControlName="drvKotsaDriverId">
            </div>
            <div class="col-md-9 offset-md-3 small mt-1">
                <small class="form-text text-muted">
                    운수종사자 관리 시스템에(drv.kotsa.or.kr) 사용되는 운수종사자ID.<br>
                    휴식시간 보장내역 자료 제출에 사용됩니다
                </small>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                생년월일
            </label>
            <div class="col-md-9 position-relative">
                <input type="date" class="form-control form-control-sm w-auto"
                       formControlName="userBirthDt">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                입사일자
            </label>
            <div class="col-md-9 position-relative">
              <input type="date" class="form-control form-control-sm w-auto"
                     formControlName="userHireDt">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                연락처
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="mobile">
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                메모
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="memo">
            </div>
        </div>

        <div class="form-group row align-items-center mb-0">
            <label class="col-md-3 mb-0">
                사용여부
            </label>
            <div class="col-md-9 position-relative">
                <select class="form-control form-control-sm w-auto"
                    formControlName="useYn">
                    <option [ngValue]="'Y'">사용</option>
                    <option [ngValue]="'N'">미사용</option>
                </select>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()"
        [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>
